import { useContext } from 'react';
import { OrganizationsContext } from './OrganizationsContext';

export function useOrganizations() {
  const ctx = useContext(OrganizationsContext);
  if (!ctx) throw new Error('useOrganizations must be used within OrganizationsProvider');
  return ctx;
}
